import React from 'react';
import PropTypes from 'prop-types';
import {StyledEngineProvider, ThemeProvider} from '@mui/material/styles';
import {useThemeContext} from '../AppContextProvider/ThemeContextProvider';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import {getAppTheme} from '../../../theme';

const AppThemeProvider = (props) => {
  const {theme, themeMode} = useThemeContext();

  // Use our centralized theme system
  const appTheme = getAppTheme(
    themeMode === 'dark' ? 'dark' : 'light',
    theme.direction === 'rtl' ? 'rtl' : 'ltr',
  );

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={appTheme}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          {props.children}
        </LocalizationProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default AppThemeProvider;

AppThemeProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
